module.exports = {"330212001":"下应街道","330212002":"钟公庙街道","330212003":"石碶街道","330212004":"梅墟街道","330212005":"中河街道","330212006":"首南街道","330212007":"潘火街道","330212100":"瞻岐镇","330212101":"咸祥镇","330212102":"塘溪镇","330212103":"东钱湖镇","330212104":"东吴镇","330212105":"五乡镇","330212106":"邱隘镇","330212108":"云龙镇","330212109":"横溪镇","330212110":"姜山镇","330212113":"高桥镇","330212114":"横街镇","330212115":"集士港镇","330212116":"古林镇","330212118":"洞桥镇","330212119":"鄞江镇","330212120":"章水镇","330212200":"龙观乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330212.json
// module id = 883
// module chunks = 0